import type { GuestAccessCommand, GuestAccessRuleDto } from '../../api/guestAccessTypes';
import type { GuestAccessRepository } from '../../repositories/ApiGuestAccessRepository';

export class GuestAccessService {
  constructor(private readonly repo: GuestAccessRepository) {}

  listRules(): Promise<GuestAccessRuleDto[]> {
    return this.repo.listRules();
  }

  listActiveRules(): Promise<GuestAccessRuleDto[]> {
    return this.repo.listActiveRules();
  }

  listBusyResources(startAt: string, endAt: string): Promise<string[]> {
    return this.repo.listBusyResources(startAt, endAt);
  }

  createRule(command: GuestAccessCommand): Promise<GuestAccessRuleDto> {
    return this.repo.createRule(command);
  }

  updateRule(id: number, command: GuestAccessCommand): Promise<GuestAccessRuleDto> {
    return this.repo.updateRule(id, command);
  }

  deleteRule(id: number): Promise<void> {
    return this.repo.deleteRule(id);
  }
}
